import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)

axios.defaults.withCredentials = false;
axios.defaults.baseURL = process.env.MIX_URL;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// let token = document.head.querySelector('meta[name="csrf-token"]');
//
// if (token) {
//     axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
// } else {
//     console.error('CSRF token not foundf');
// }
// axios.defaults.baseURL = 'http://130.193.50.225:9116';
// axios.defaults.headers.common['Authorization'] = 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1lIjoic2l0ZSIsIlVzZXJDbGFpbXMiOiJ7XCJMb2dpblwiOlwic2l0ZVwiLFwiRW1haWxcIjpcInNpdGVAZ2tkLnJ1XCIsXCJJZFwiOlwiMGQxZTI2YzEtMGViMi00ZDkxLWFkNjItNWQ0YjA5NWVlNDYyXCIsXCJGaXJzdE5hbWVcIjpcItCj0YfQtdGC0L3QsNGPXCIsXCJMYXN0TmFtZVwiOlwi0JfQsNC_0LjRgdGMXCIsXCJNaWRkbGVOYW1lXCI6XCLQodCw0LnRgtCwXCIsXCJJc1NlcnZpY2VcIjpmYWxzZSxcIkFjY2Vzc1Rva2VuSWRlbnRpdHlTZXJ2ZXJcIjpudWxsLFwiQWRkaXRpb25hbFByb3BlcnRpZXNcIjp7fSxcIlJvbGVzXCI6W1wiS3JlbWxpbkNhc2hpZXJcIl19IiwiaHR0cDovL3NjaGVtYXMubWljcm9zb2Z0LmNvbS93cy8yMDA4LzA2L2lkZW50aXR5L2NsYWltcy9yb2xlIjoiS3JlbWxpbkNhc2hpZXIiLCJuYmYiOjE1OTAxMzYxNDksImV4cCI6MTU5NTMyMDE0OSwiaXNzIjoiQ3JlbWxpbldlYkFwaSIsImF1ZCI6Imh0dHA6Ly9sb2NhbGhvc3QifQ.kvYOAQ5-ovRw7t4p-w2v7Opd-5qnKlsJvjT0eeB9v3E';

// axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
